import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen bg-[#0A0F2C] flex items-center justify-center p-4">
      <Card className="glass-card w-full max-w-md">
        <CardContent className="p-8 text-center animate-slide-up">
          <div className="w-20 h-20 rounded-full bg-yellow-500/20 flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-yellow-400" />
          </div>
          <h1 className="text-2xl font-bold text-white font-['Outfit'] mb-2">
            Pago cancelado
          </h1>
          <p className="text-white/60 mb-6">
            Has cancelado el proceso de pago. No se realizó ningún cargo.
          </p>
          <Link to="/wallet">
            <Button className="btn-primary w-full">
              <ArrowLeft className="w-5 h-5 mr-2" />
              Volver a Wallet
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
